module.exports = __webpack_public_path__ + "media/Prpt.ad5005f8.jpg";